import { render, staticRenderFns } from "./InputTextSearch.vue?vue&type=template&id=54a43862"
import script from "./InputTextSearch.vue?vue&type=script&lang=ts"
export * from "./InputTextSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports